export default {
	'add-new-news': '',
	'the-news': '',
	news: '',
}